import { DIID } from "@archipad-js/dependency-injection";
import { DependencyBundle } from "@archipad/backend/project/dependenciesManager";
import _LegacyServiceManager from "@core/services/legacy-service-manager";

export const Dependencies_Cache_Service_DIID = DIID<DependenciesCacheServiceI>('DependenciesCacheServiceDIID');
export interface DependenciesCacheServiceI {
    getDependencyBundle(identifier: string): Promise<DependencyBundle[] | null>;
    setDependencyBundle(data: {
            key: string;
            bundles: DependencyBundle[];
        }): Promise<void>;
    getProjectDependenciesCache(dependencies: string[], projectId?: string): Promise<ProjectDependenciesData | null>;
    setProjectDependenciesCache(data: {
            projectId: string;
            dependencies: string[];
            data: ProjectDependenciesData;
        }): Promise<void>;

    clearCache(): Promise<void>;
}

export type ProjectDependenciesData =  {
            baseURI?: string;
            packaging?: string;
            path?: string;
            size?: number;
            versionTag?: string;
            uri?: string;
}[][];

// Node workers (project-sync, archiswap...) have no IndexedDB-backed cache
const noopDependenciesCacheService: DependenciesCacheServiceI = {
    getDependencyBundle: () => Promise.resolve(null),
    setDependencyBundle: () => Promise.resolve(),
    getProjectDependenciesCache: () => Promise.resolve(null),
    setProjectDependenciesCache: () => Promise.resolve(),
    clearCache: () => Promise.resolve(),
};

export function getDependenciesCacheService(): DependenciesCacheServiceI {
    const container = _LegacyServiceManager.container;
    if (!container.isBound(Dependencies_Cache_Service_DIID.symbol)) {
        return noopDependenciesCacheService;
    }
    return container.get(Dependencies_Cache_Service_DIID.symbol);
}
